import { onlinesShippingtemplateList } from "@/api/onlines/goods.js";
export const mixinShippingTemplate = {
  computed: {
  },
  data() {
    return {
      shippingTempliteList: []
    }
  },
  methods: {
    /**
     * 获取所有运费模板
     */
    async getTemplateList() {
      const res = await onlinesShippingtemplateList();
      console.log(res);
      this.shippingTempliteList = res;
    }
  }
}